import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'oa-quick-launch',
  name: '快捷发起',
  icon: '发',
  group: 'OA 组件',
  description: '展示当前租户已发布的流程快捷入口。',
  defaultProps: {
    title: '发起流程',
    limit: 8
}
}
